const USERS_URL = "/users";

export async function addUser(axiosPrivate, formData) {
  try {
    const response = await axiosPrivate.post(USERS_URL, formData);
    return response;
  } catch (err) {
    console.error(err);
  }
}
